import { Component, Input, OnInit } from "@angular/core";
import { DateTime } from "luxon";
import { WidgetsService } from "src/app/shared/services/widgets.service";

@Component({
  selector: 'widget-form',
  templateUrl: './widget-form.component.html',
  styleUrls: ['./widget-form.component.scss']
})
export class WidgetFormComponent implements OnInit {
  @Input() widgetConfig;
  formName = null;
  stageId = null;
  percentage = 0;
  buttonText = 'Loading...';
  buttonLink = '';
  background = 'radial-gradient(closest-side, white 85%, transparent 80% 100%), conic-gradient(#FFAD34 0%, #F2F3F5 0)';
  isDeadlinePassed = false;
  isSubmitted = false;
  isEliminated = false;
  notStarted = false;
  loading: boolean = true;
  failedToLoad: boolean = false;

  constructor(private widgetsService: WidgetsService) { }

  ngOnInit() {
    this.init()
  }

  async init() {
    this.loading = true;
    this.stageId = this.widgetConfig?.widgetSettings?.stageId;
    if (!this.stageId) return;

    try {
      const res: any = await this.widgetsService.getFormWidgetData(this.stageId).toPromise();
      this.failedToLoad = false;
      const currentDate = DateTime.fromJSDate(new Date()).setZone('UTC').toISO();
      this.notStarted = currentDate < res.stageStartDate;
      this.isEliminated = res.isEliminated;
      this.formName = res.stageName;
      this.isSubmitted = res.isSubmitted;
      this.percentage = res.formPercentComplete || 0;
      this.isDeadlinePassed = currentDate > res.stageEndDate && !this.isSubmitted;
      this.loading = false;

      if (res.stageType.includes('Application')) {
        this.buttonLink = `/application`;
      } else if (res.stageType.includes('Registration')) {
        this.buttonLink = `/registration`;
      } else {
        this.buttonLink = `/form/${res.stageId}`;
      }
      if (this.isDeadlinePassed) {
        this.buttonText = `View`;
      } else if (this.percentage === 0) {
        this.buttonText = `Start`;
      } else if (this.percentage <= 99) {
        this.buttonText = `Continue`;
      } else if (this.percentage === 100 && !this.isSubmitted) {
        this.buttonText = `Submit`;
      } else if (this.percentage === 100 && this.isSubmitted) {
        this.buttonText = `View`;
      }

      // radial gradient is used to make white circle with transparent edges from the inside toward the outside
      // conic gradient is used to make the arch, colors are rotating from left to right with a 0.8deg offset on the edge of the colored part to avoid sharp edges
      // the visible part of the conic gradient is the area with transparent edge from the radial gradient
      // the conic gradient has two colored arches, one from start to the middle and one from the middle to the end, followed by 0.8deg almost white color
      if (this.percentage === 0) {
        this.background = `radial-gradient(closest-side, #fff 85%, transparent 86% 100%), conic-gradient(${this.calculateColor(this.percentage)[0]} ${this.percentageToCircularDegrees(this.percentage)/2}deg, #F2F3F5 calc(${this.percentageToCircularDegrees(this.percentage)}deg + 0deg))`;
      } else {
        this.background = `radial-gradient(closest-side, #fff 85%, transparent 86% 100%), conic-gradient(${this.calculateColor(this.percentage)[0]} ${this.percentageToCircularDegrees(this.percentage)/2}deg, ${this.calculateColor(this.percentage)[1]} ${this.percentageToCircularDegrees(this.percentage)}deg, #F2F3F5 calc(${this.percentageToCircularDegrees(this.percentage)}deg + 0.8deg))`;
      }
    } catch (error) {
      this.loading = false;
      this.failedToLoad = true;
      console.log(error);
    }
  }

  calculateColor(percentage: number) {
    if (percentage >= 0 && percentage <= 24 ) return ['#fe6842', '#ff8422'];
    if (percentage >= 25 && percentage <= 49) return ['#ff8442', '#ffa734'];
    if (percentage >= 50 && percentage <= 74) return ['#ffa734', '#f6c71c'];
    if (percentage >= 75 && percentage < 100) return ['#85d828', '#3cc224'];
    if (percentage === 100) return ['#35b657', '#2fa44e'];
  }

  percentageToCircularDegrees(percentage: number) {
    return percentage * 3.6;
  }

  reloadWidget() {
    this.init();
  }
}
